import { UseFormReturn } from "react-hook-form"
import { useFetchCitiesEnabled, useFetchGetPais, useFetchProvinces, useFetchSectors, useFetchZones } from "../actions/erp"

interface Localidad {
  pais?: string
  provincia?: string
  ciudad?: string
  zona?: string
  sector?: string
}


interface UseLocalidadProps {
  form: UseFormReturn<Localidad, any, undefined>
  cobertura?: boolean
  withoutControl?: boolean
}

export function useLocalidad({
  form,
  cobertura,
  withoutControl = false
}: UseLocalidadProps) {

  ///* react query

  const {
    isLoading: isLoadingPais,
    data: dataPais
  } = useFetchGetPais({
    page_size: 600,
    estado: true
  })

  const {
    isLoading: isLoadingProvincia,
    data: dataProvincia
  } = useFetchProvinces({
    pais: withoutControl?undefined:form.watch().pais,
    page_size: 600,
    estado: true,
    cobertura
  }, withoutControl?true:!!form.getValues().pais)

  const {
    isLoading: isLoadingCiudad,
    data: dataCiudad
  } = useFetchCitiesEnabled({
    params: {
      provincia: withoutControl?undefined:form.watch().provincia,
      page_size: 600,
      estado: true,
      cobertura
    },
    enabled: withoutControl?true:!!form.getValues().provincia
  })

  const {
    isLoading: isLoadingZona,
    data: dataZona
  } = useFetchZones({
    ciudad: withoutControl?undefined:form.getValues().ciudad,
    page_size: 600,
    estado: true,
    cobertura
  }, withoutControl?true:!!form.getValues().ciudad)

  const {
    isLoading: isLoadingSector,
    data: dataSector
  } = useFetchSectors({
    zona: withoutControl?undefined:form.getValues().zona,
    page_size: 600,
    estado: true,
    cobertura
  }, withoutControl?true:!!form.getValues().zona)


  function handleReset(tipo: string) {
    // Mapeo de cada tipo con los campos que se deben reiniciar
    const resetFields: Record<string, string[]> = {
      PAIS: ['provincia', 'ciudad', 'zona', 'sector', 'nodo'],
      PROVINCIA: ['ciudad', 'zona', 'sector', 'nodo'],
      CIUDAD: ['zona', 'sector', 'nodo'],
      ZONA: ['sector', 'nodo'],
    };

    // Obtenemos los campos a resetear según el tipo
    const fields = resetFields[tipo];
    if (!fields) return; // Si el tipo no coincide, no se realiza nada

    // Obtenemos los valores actuales del formulario
    const currentValues = form.getValues();

    // Creamos una copia de los valores y reiniciamos los campos requeridos
    const updatedValues = { ...currentValues } as Record<string, string | null>;

    fields.forEach((field) => {
      updatedValues[field] = null;
    });

    // Reiniciamos el formulario con los nuevos valores
    form.reset(updatedValues);

  }

  return {
    dataPais,
    isLoadingPais,
    dataProvincia,
    isLoadingProvincia,
    dataCiudad,
    isLoadingCiudad,
    dataZona,
    isLoadingZona,
    dataSector,
    isLoadingSector,

    handleReset
  }

}